import magnificPopup from 'magnific-popup';

window.modalOpen = function (src, type, fallback){
  $.magnificPopup.open({
    items: {
      src: src,
      type: type
    },
    iframe: {
      markup: `
        <div class="mfp-iframe-scaler">
            <div class="mfp-close"></div>
            <iframe class="mfp-iframe" frameborder="0" allowfullscreen><img src="${fallback}"/></iframe>
        </div>
      `,
      srcAction: 'iframe_src'  
    },
    closeBtnInside: true,
    callbacks: {
      beforeOpen: function() {
        $('body').addClass('noscroll');
        if ($('.js-mobile-subscribe')) {
          $('.js-mobile-subscribe').removeClass('visible');
        }

        $('html').addClass('mfp-open');


      },

      beforeClose: function(){
        if ($('.js-mobile-subscribe')) {
          $('.js-mobile-subscribe').addClass('visible');
        }

        $('html').removeClass('mfp-open');

        if (typeof (chooseCity) === 'function' && $('.mfp-content #modalCity').length > 0) {
          let objectModalContent = $(src);

          chooseCity(objectModalContent);
        }

        $('body').removeClass('noscroll');
      },
      ajaxContentAdded: function(){
        validationInit();
        initPhoneMask();

        if (typeof (initGetRequest) === 'function' && $('.mfp-content #modalEntries').length > 0) {
          initGetRequest();
        }
      },
    }
  });
}

$(document).on('click', '.js-modalLink', function(event) {
  // закрытие мобильного меню при открытие модалок из меню
  if ($('.js-menuMobile').hasClass('is_show')) {
    $('.js-closeMenuMobile').trigger('click')
  }

  $(this).trigger('focus');

  let src = $(this).data('mfp-src'),
      type = $(this).data('mfp-ajax') || 'inline',
      fallback = src


  if ($(this).attr('data-mfp-image')) {
    type = 'image';
  }

  console.log('src ', src)
  console.log('type ', type)
  console.log('pdf ', $(this).attr('data-doc-src'))

  event.preventDefault();

  if ($(this).attr('data-doc-src')) {
    src  = $(this).attr('data-doc-src')
    window.open(src, '_blank');
  } else {
    modalOpen(src, type, fallback);
  }
});

$(document).on('click', '.js-modalClose', function(event) {
  event.preventDefault();
  $.magnificPopup.close();
});
